import React, { useState, useEffect } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, FormControl, FormLabel, Input, Select } from '@chakra-ui/react';
import { BASE_URL } from '../../Globalapi/Globalapi';

const EditClassModal = ({ isOpen, onClose, classId, fetchClassData }) => {
    const [classDetails, setClassDetails] = useState({
        class_id: '',
        division_id: '',
        section_id: '',
        min_students: '',
        max_students: '',
    });

    const [classes, setClasses] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [sections, setSections] = useState([]);

    useEffect(() => {
        if (isOpen) {
            // Fetch class, division, and section data
            Promise.all([
                fetch(`${BASE_URL}/admin/class/class_master.php`).then(res => res.json()),
                fetch(`${BASE_URL}/admin/class/division.php`).then(res => res.json()),
                fetch(`${BASE_URL}/admin/class/section.php`).then(res => res.json())
            ])
                .then(([classData, divisionData, sectionData]) => {
                    setClasses(classData.data || []);
                    setDivisions(divisionData.data || []);
                    setSections(sectionData.data || []);
                })
                .catch(error => console.error('Error fetching data:', error));

            if (classId) {
                console.log('Fetching class details for classId:', classId);
                fetch(`${BASE_URL}/admin/class/list_single_class.php?class_details_id=${classId}`)
                    .then(response => response.json())
                    .then(data => {
                        console.log('Fetched Class Details:', data);
                        if (data && data.success) {
                            setClassDetails(data.SingleClassData);
                        } else {
                            console.error('Error fetching class details:', data.message);
                        }
                    })
                    .catch(error => console.error('Error fetching class details:', error));
            } else {
                console.error('classId is not provided');
            }
        }
    }, [isOpen, classId]);

    const handleChange = (e) => {
        setClassDetails({
            ...classDetails,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = () => {
        console.log('Sending data to backend:', {
            class_id: classDetails.class_id,
            division: classDetails.division_id,
            section: classDetails.section_id,
            min_students: classDetails.min_students,
            max_students: classDetails.max_students,
            class_details_id: classId
        });

        fetch(`${BASE_URL}/admin/class/edit_class.php`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                class_id: classDetails.class_id,
                division: classDetails.division_id,
                section: classDetails.section_id,
                min_students: classDetails.min_students,
                max_students: classDetails.max_students,
                class_details_id: classId
            })
        })
            .then(response => response.json())
            .then(data => {
                console.log('Update Response:', data);
                if (data.success) {
                    fetchClassData();
                    onClose();
                } else {
                    console.error('Error updating class details:', data.message);
                }
            })
            .catch(error => console.error('Error updating class details:', error));
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Edit Class</ModalHeader>
                <ModalBody>
                    <FormControl mb={4}>
                        <FormLabel>Class</FormLabel>
                        <Select name="class_id" value={classDetails.class_id} onChange={handleChange}>
                            <option value="">Select Class</option>
                            {classes.map(cls => (
                                <option key={cls.id} value={cls.id}>{cls.class}</option>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl mb={4}>
                        <FormLabel>Division</FormLabel>
                        <Select name="division_id" value={classDetails.division_id} onChange={handleChange}>
                            <option value="">Select Division</option>
                            {divisions.map(div => (
                                <option key={div.id} value={div.id}>{div.division}</option>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl mb={4}>
                        <FormLabel>Section</FormLabel>
                        <Select name="section_id" value={classDetails.section_id} onChange={handleChange}>
                            <option value="">Select Section</option>
                            {sections.map(sec => (
                                <option key={sec.id} value={sec.id}>{sec.section}</option>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl mb={4}>
                        <FormLabel>Min No of Students</FormLabel>
                        <Input name="min_students" type="number" value={classDetails.min_students} onChange={handleChange} />
                    </FormControl>
                    <FormControl mb={4}>
                        <FormLabel>Max No of Students</FormLabel>
                        <Input name="max_students" type="number" value={classDetails.max_students} onChange={handleChange} />
                    </FormControl>
                    {/* <FormControl mb={4}>
                        <FormLabel>Assigned Teacher</FormLabel>
                        <Input name="class_teacher_id" value={classDetails.class_teacher_id} onChange={handleChange} />
                    </FormControl> */}
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="blue" onClick={handleSubmit}>Save</Button>
                    <Button variant="ghost" onClick={onClose}>Cancel</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default EditClassModal;
